<template>
  <div class="custom-tab-container">
    <div class="tab-group">
      <div
        v-if="hasPickup"
        class="tab"
        :class="{ active: selectedTab === 'pickup', disabled: !hasPickup }"
        @click="hasPickup && selectTab('pickup')"
      >
        <v-icon>mdi-walk</v-icon>
        <span>{{ hasPickup ? "Pickup" : "Pickup (Not set)" }}</span>
      </div>
      <div
        v-if="hasDelivery"
        class="tab"
        :class="{ active: selectedTab === 'delivery', disabled: !hasDelivery }"
        @click="hasDelivery && selectTab('delivery')"
      >
        <v-icon>mdi-truck-delivery</v-icon>
        <span>{{ hasDelivery ? "Delivery" : "Delivery (Not set)" }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomTab",
  data() {
    return {
      selectedTab: "pickup",
      hasPickup: false,
      hasDelivery: false,
    };
  },
  mounted() {
    const services = this.$store.getters.deliveryServicesList || [];
    const serviceNames = services.map((service) => service.serviceName);
    this.hasPickup = serviceNames.includes("Pickup");
    this.hasDelivery = serviceNames.includes("Delivery");

    // Optional: Automatically emit selected tab if only one service is available
    if (!this.hasPickup && this.hasDelivery) {
      this.selectTab("delivery");
    } else if (this.hasPickup && !this.hasDelivery) {
      this.selectTab("pickup");
    }
  },
  methods: {
    selectTab(tab) {
      const services = [];
      console.log("Services: ", this.$store.getters.deliveryServicesList);
      for (const service of this.$store.getters.deliveryServicesList) {
        if (service.serviceName === "Pickup") {
          services.push("Pickup");
        } else if (service.serviceName === "Delivery") {
          services.push("Delivery");
        }
      }

      if (services.length > 0) {
        this.hasPickup = services.includes("Pickup");
        this.hasDelivery = services.includes("Delivery");

        if (this.hasPickup && tab === "pickup") {
          this.selectedTab = tab;
          this.$emit("tab-change", tab);
        } else if (this.hasDelivery && tab === "delivery") {
          this.selectedTab = tab;
          this.$emit("tab-change", tab);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.custom-tab-container {
  width: 100%;
  padding: 8px;

  .tab-group {
    display: flex;
    background-color: #f2f2f2;
    border-radius: 50px;
    overflow: hidden;
    padding: 4px;
    border: 1px solid #e0e0e0;

    .tab {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 24px;
      cursor: pointer;
      transition: all 0.3s ease;
      color: #777;
      gap: 8px;
      border-radius: 9999px;

      &.active {
        background-color: #ffffff;
        color: #000;
        font-weight: 600;
        box-shadow: none;
      }

      .v-icon {
        font-size: 18px;
      }

      span {
        font-size: 16px;
      }
    }

    // Responsive styles
    @media (max-width: 600px) {
      .tab {
        padding: 8px 12px;

        .v-icon {
          font-size: 16px;
        }

        span {
          font-size: 14px;
        }
      }
    }

    @media (max-width: 400px) {
      .tab {
        padding: 6px 8px;

        .v-icon {
          font-size: 14px;
        }

        span {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
